module.exports = __webpack_public_path__ + "img/cruzeiro.97afd376.jpeg";